import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { PlayCircle, ArrowRight, Award, Wrench, Clock, Settings, Zap } from 'lucide-react';
import { features } from '../data/mock';

const iconMap = [Award, Wrench, Settings, Zap, Clock];

const ExperienceSection = () => {
  return (
    <section className="py-28 relative overflow-hidden" style={{ background: 'linear-gradient(180deg, #050F2E 0%, #0A2A63 100%)' }}>
      <div className="absolute inset-0 opacity-30 grain-overlay pointer-events-none" />
      <div className="absolute top-1/4 right-0 h-80 w-80 rounded-full bg-[#FF4E50]/20 blur-3xl" />

      <div className="container-pn relative grid md:grid-cols-12 gap-12 items-center text-white">
        {/* Left: Copy */}
        <div className="md:col-span-7">
          <p className="text-xs uppercase tracking-[0.3em] text-[#FF4E50] font-bold mb-3">88 Years of Experience</p>
          <h2 className="text-4xl md:text-6xl font-black tracking-tight leading-[1.03]">
            Capitalize the <span className="text-[#FF4E50]">P</span> in Printing your Vision
          </h2>
          <p className="mt-6 text-lg text-slate-300 max-w-2xl leading-relaxed">
            Difficulty in any sector or process of your business? Contact a specialist. We can help at every stage — reducing costs, improving processes and ensuring quality.
          </p>

          <ul className="mt-10 grid sm:grid-cols-2 gap-4">
            {features.map((f, i) => {
              const Icon = iconMap[i] || Award;
              return (
                <li key={f} className="flex items-start gap-3 bg-white/5 hover:bg-white/10 transition-colors rounded-xl p-4 border border-white/10">
                  <span className="h-10 w-10 rounded-lg bg-[#FF4E50] flex items-center justify-center flex-shrink-0">
                    <Icon className="h-5 w-5 text-[#050F2E]" />
                  </span>
                  <span className="font-semibold leading-snug pt-1.5">{f}</span>
                </li>
              );
            })}
          </ul>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <Link to="/contact">
              <Button className="bg-[#FF4E50] hover:bg-[#FF7273] text-[#050F2E] rounded-full h-13 px-7 font-bold btn-transition">
                Contact a specialist
                <ArrowRight className="h-4 w-4 ml-2" />
              </Button>
            </Link>
            <a
              href="https://www.youtube.com/embed/znIyaGS5BNc"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 text-slate-300 hover:text-white font-semibold"
            >
              <PlayCircle className="h-6 w-6" /> Watch our story
            </a>
          </div>
        </div>

        {/* Right: Stats */}
        <div className="md:col-span-5 grid grid-cols-2 gap-5">
          <div className="bg-white/5 rounded-2xl p-7 border border-white/10 backdrop-blur-sm">
            <p className="text-5xl md:text-6xl font-black text-white">+400</p>
            <p className="text-sm text-slate-400 mt-2">Active customers worldwide</p>
          </div>
          <div className="bg-[#FF4E50] text-[#050F2E] rounded-2xl p-7">
            <p className="text-5xl md:text-6xl font-black">88y</p>
            <p className="text-sm font-semibold mt-2">Combined experience</p>
          </div>
          <div className="bg-white/5 rounded-2xl p-7 border border-white/10 backdrop-blur-sm">
            <p className="text-5xl md:text-6xl font-black text-white">75+</p>
            <p className="text-sm text-slate-400 mt-2">Countries served</p>
          </div>
          <div className="bg-white text-[#050F2E] rounded-2xl p-7">
            <p className="text-5xl md:text-6xl font-black">10M+</p>
            <p className="text-sm font-semibold mt-2">Colors managed</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
